import {
  Card,
  Container,
  CardHeader,
  Divider,
  Grid,
  CardContent,
  createMuiTheme,
  Select,
  Typography,
  FormControl,
  TextField,
  CardActions,
  Button,
  CircularProgress,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  InputAdornment,
  DialogContent,
  DialogTitle,
  Dialog,
  DialogActions,
  Slide,
  LinearProgress,
  TableContainer,
  Checkbox,
  Backdrop,
  Slider,
  Input,
  Snackbar,
  TableSortLabel
} from '@material-ui/core';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import React, { useState } from 'react';
import Page from 'src/components/Page';
import { CustomTableCell } from 'src/components/CustomTableCell';
import axios from 'src/utils/axios';
import LockIcon from '@material-ui/icons/Lock';
import {
  getUser,
  sc,
  GetWarehouseAddress,
  getSepetAdet,
  setSepetAdet,
  CreateWareHouseAddress
} from 'src/utils/Common';
import DateFnsUtils from '@date-io/date-fns';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';
import SearchIcon from '@material-ui/icons/Search';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import CloseIcon from '@material-ui/icons/Close';
import GenericBulten from 'src/components/GenericBulletin';
import SendIcon from '@material-ui/icons/Send';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import AddressSearch from 'src/components/Selects/AddressSearch';
import CropFreeIcon from '@material-ui/icons/CropFree';
import clsx from 'clsx';
import BarcodeVoice from 'src/assets/sound/Bip.mp3';
import ErrorVoice from 'src/assets/sound/Error.mp3';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import MuiAlert from '@material-ui/lab/Alert';


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  cardUstBolum: {
    maxHeight: 700,
    minHeight: 700,
    width: '100%'
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  container: {
    maxHeight: 497,
    minHeight: 497,
    mimWidth: 500
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});
const localeMap = {
  tr: trLocale
};


function Branch() {
  const classes = useStyles();
  const today = moment(new Date()).format('YYYY-MM-DD');
  const [SubeKodu, setSubeKodu] = useState('');
  const [SubeData, setSubeData] = useState([]);
  const [SubeZimmetData, setSubeZimmetData] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [WarehouseAddress, setWarehouseAddress] = useState([]);
  const [bultenOpen, setBultenOpen] = React.useState(false);
  const [bultenParam, setBultenParam] = React.useState('');
  const [LoadingMaterial, setLoadingMaterial] = React.useState(true);
  const [ImageUrl, setImageUrl] = useState(null);
  const [openMaterialFileTitle, setOpenMaterialFileTitle] = React.useState('');
  const [openMaterialFile, setOpenMaterialFile] = React.useState(false);
  const [previous, setPrevious] = React.useState({});
  const [selected, setSelected] = React.useState([]);
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const SessionUser = getUser();
  const [Barcode, setBarcode] = useState('');
  const likeAudio = new Audio(BarcodeVoice);
  const ErrorAudio = new Audio(ErrorVoice);
  const [SiparisAdetTitle, setSiparisAdetTitle] = React.useState('');
  const [openSiparisAdet, setopenSiparisAdet] = React.useState(false);
  const [MalzemeSiparis, setMalzemeSiparis] = React.useState('');
  const [siparisAdet, setsiparisAdet] = React.useState(1);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const handleSubeChange = e => {
    onSorgulaSube(e.target.value);
    setSubeKodu(e.target.value);
    setSubeZimmetData([]);
  };

  const onChange = (e, row) => {
    if (!previous[row.MALZEME_STOK_NO]) {
      setPrevious(state => ({ ...state, [row.MALZEME_STOK_NO]: row }));
    }
    var value = e.target.value;
    const name = e.target.name;
    if (parseInt(value) < 0) {
      value = 1;
    }
    const newRows = SubeZimmetData.map(item => {
      if (
        item.MALZEME_STOK_NO === row.MALZEME_STOK_NO &&
        item.FIS_NO === row.FIS_NO
      ) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setSubeZimmetData(newRows);
  };

  React.useEffect(() => {
    CreateWareHouseAddress(SessionUser.ServiceShopId);
    axios
      .get(`/GetTechnicianDebit/${SessionUser.ServiceShopId}/${0}/${0}`)
      .then(response => {
        if (response.data.length > 0) {
          setSubeData(response.data);
        }
      })
      .catch(error => {
        console.log(error);
      });
    var DegerWarehouseAddress = [];
    DegerWarehouseAddress = GetWarehouseAddress(SessionUser.ServiceShopId);
    setWarehouseAddress(DegerWarehouseAddress);
  }, []);

  function onSorgula() {
    if (SubeKodu === '') {
      setUyariTip('error');
      setUyariAciklama("Şube Seçiniz!...");
      setUyari(true);
      return;
    }
    setLoading(true);
    axios
      .get(
        `/GetSubeMaterial/${SessionUser.ServiceShopId}/${SubeKodu}`
      )
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          setSubeZimmetData(response.data);
          axios
            .get(`/GetTechnicianDebit/${SessionUser.ServiceShopId}/${0}/${0}`)
            .then(response => {
              if (response.data.length > 0) {
                setSubeData(response.data);
                setSubeKodu(SubeKodu);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          setSubeZimmetData([]);
          axios
            .get(`/GetTechnicianDebit/${SessionUser.ServiceShopId}/${0}/${0}`)
            .then(response => {
              if (response.data.length > 0) {
                setSubeData(response.data);
                setSubeKodu(SubeKodu);
              }
            })
            .catch(error => {
              console.log(error);
            });
        }



      })
      .catch(error => {
        setLoading(false);
        console.log(error);
      });
  }

  function onSorgulaSube(BirimKodu) {
    if (BirimKodu === '') {
      setUyariTip('error');
      setUyariAciklama("Şube Seçiniz!...");
      setUyari(true);
      return;
    }
    setLoading(true);
    axios
      .get(
        `/GetSubeMaterial/${SessionUser.ServiceShopId}/${BirimKodu}`
      )
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          setSubeZimmetData(response.data);
          axios
            .get(`/GetTechnicianDebit/${SessionUser.ServiceShopId}/${0}/${0}`)
            .then(response => {
              if (response.data.length > 0) {
                setSubeData(response.data);
                setSubeKodu(BirimKodu);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          setSubeZimmetData([]);
          axios
            .get(`/GetTechnicianDebit/${SessionUser.ServiceShopId}/${0}/${0}`)
            .then(response => {
              if (response.data.length > 0) {
                setSubeData(response.data);
                setSubeKodu(BirimKodu);
              }
            })
            .catch(error => {
              console.log(error);
            });
        }



      })
      .catch(error => {
        setLoading(false);
        console.log(error);
      });
  }


  const GetMaterialImage = (event, materialCode) => {
    setOpenMaterialFile(true);
    setLoadingMaterial(true);
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    setOpenMaterialFileTitle(materialCode + ' Numaralı Malzeme Detayı');
    axios
      .get(`MaterialFile/${materialCode}`, config)
      .then(response => {
        var fileURL = URL.createObjectURL(response.data);
        setImageUrl(fileURL);
        setLoadingMaterial(false);
      })
      .catch(error => {
        setLoadingMaterial(false);
      });
  };
  const GetMaterialBulletin = (event, materialCode) => {
    setBultenParam(materialCode);
    setBultenOpen(true);
    setLoadingMaterial(false);
  };
  const handleCloseMaterialFile = () => {
    setOpenMaterialFile(false);
  };
  const isSelected = name => selected.indexOf(name) !== -1;

  const handleClick = (event, row, index) => {
    if (row.RowSelected === 0) {
      row.RowSelected = 1;
    } else {
      row.RowSelected = 0;
    }
    let SubeZimmetDataOld = [...SubeZimmetData];
    setSubeZimmetData(SubeZimmetDataOld);
  };
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const CikisYapDetay = event => {
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    const SendData = SubeZimmetData.filter(
      d => parseInt(d.RowSelected) === parseInt(1)
    );

    const KontrolAdet = SendData.filter(d => parseInt(d.Count) > parseInt(d.ADRES_ADET));

    if (KontrolAdet.length > 0) {
      setUyariTip('error');
      setUyariAciklama("Çıkış yapılmaya çalışılan malzeme adedi depo adres adedinden fazla lütfen kontrol ediniz!...");
      setUyari(true);
      return;
    }


    const data = SendData.map(item => ({
      ServiceShopId: SessionUser.ServiceShopId,
      BranchId: SubeKodu,
      ServicePaperNr: item.FIS_NO,
      MaterialCode: item.MALZEME_STOK_NO,
      Count: item.Count,
      WarehouseAddress: item.WarehouseAddress,
      UserId: SessionUser.OrganizationUserId,
    }));




    axios
      .post('/SetBranchExitSendtoCenter', data, config)
      .then(response => {
        setLoading(false);
        setUyariTip('success');
        onSorgula();
        let ResponseData = response.data[0];
        setUyariAciklama(ResponseData.ErrorDescription);
        setUyari(true);
      });
  };

  const CikisYap = event => {
    if (
      SubeZimmetData.filter(d => parseInt(d.RowSelected) === parseInt(1))
        .length === 0
    ) {
      setUyariTip('error');
      setUyariAciklama('Seçim yapmadınız!... Lütfen önce seçim yapınız!...');
      setUyari(true);
      return;
    }


    confirmAlert({
      message: 'Sadece seçim yapılan satırlar için işlem yapılacaktır!...',
      buttons: [
        {
          label: 'Evet',
          onClick: () => CikisYapDetay(event)
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };
  const playSound = audioFile => {
    audioFile.play();
  };

  const SetBarcodeAddItemKabul = (Barcode, Data) => {
    setLoading(true);
    axios
      .get(
        `/SetMaterialBranchDebit/${SessionUser.ServiceShopId
        }/${SubeKodu}/${Barcode}/${1}`
      )
      .then(response => {
        setLoading(false);
        var ID = response.data.split('|')[0];
        var DEPO_ADET = response.data.split('|')[1];
        var ADRES_ADET = response.data.split('|')[2];
        var WarehouseAddressText = response.data.split('|')[3];
        var WarehouseAddress = response.data.split('|')[4];

        let Deger = {
          AKTIF_MUADIL: '',
          Count: 1,
          DEPO_ADET: DEPO_ADET,
          FIS_NO: ID,
          KULLANILABILIR_ADET: 1,
          MALZEME: Data,
          MALZEME_KODU: 0,
          MALZEME_STOK_NO: Barcode,
          MIKTAR: 1,
          MODEL_KODU: 0,
          PASIF_MUADIL: '',
          RowSelected: 0,
          SIPARISADET: 0,
          SIPARISNO: 'Yok - Yok',
          SIPARIS_TARIHI_FARKI: 100,
          SIP_VERILEBILIR: 1,
          SORUN: 0,
          TARIH: '-',
          WarehouseAddress: WarehouseAddress,
          ID: ID,
          ADRES_ADET: ADRES_ADET,
          WarehouseAddressText: WarehouseAddressText,
          IDKONTROL: ID + Barcode
        };

        var VarMi = SubeZimmetData.filter(d => d.FIS_NO === 'Fişsiz Malzeme|' + ID && d.MALZEME_STOK_NO === Barcode);
        if (VarMi.length > 0) {
          var rowsParam = [...SubeZimmetData];
          var rowsParamIndex = SubeZimmetData.findIndex(d => d.FIS_NO === 'Fişsiz Malzeme|' + ID && d.MALZEME_STOK_NO === Barcode);
          rowsParam[rowsParamIndex].Count = parseInt(rowsParam[rowsParamIndex].Count) + 1;
          rowsParam[rowsParamIndex].MIKTAR = parseInt(rowsParam[rowsParamIndex].MIKTAR) + 1;
          rowsParam[rowsParamIndex].DEPO_ADET = DEPO_ADET;
          rowsParam[rowsParamIndex].WarehouseAddress = WarehouseAddress;
          rowsParam[rowsParamIndex].ADRES_ADET = ADRES_ADET;
          rowsParam[rowsParamIndex].WarehouseAddressText = WarehouseAddressText;
          setSubeZimmetData(rowsParam);
        } else {
          let DegerOld = [Deger, ...SubeZimmetData];
          setSubeZimmetData(DegerOld);
        }

        setBarcode("");
      })
      .catch(error => {
        setLoading(false);
        console.log(error);
      });
  };

  const SetMaterialDelete = (event, row, ID) => {
    confirmAlert({
      message:
        'Talepte bulunulan malzeme silinecektir!... Devam etmek istediğinizden emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => {
            SetMaterialDeleteKabul(event, row, ID);
          }
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const SetMaterialDeleteKabul = (event, row, ID) => {
    setLoading(true);
    axios
      .get(`/SetMaterialBranchDebitDelete/${ID}`)
      .then(response => {
        setLoading(false);
        var SubeZimmetDataParam = [...SubeZimmetData];
        var filteredIndex = SubeZimmetDataParam.findIndex(
          x => x.ID === ID
        );
        SubeZimmetDataParam.splice(filteredIndex, 1);
        setSubeZimmetData(SubeZimmetDataParam);
      })
      .catch(error => {
        setLoading(false);
        console.log(error);
      });
  };

  const SetBarcodeAddItem = Barcode => {
    if (Barcode === '') {
      return;
    }
    playSound(ErrorAudio);
    var Varmi = SubeZimmetData.filter(
      d => d.MALZEME_STOK_NO === Barcode && d.FIS_NO === 'Fişsiz Malzeme'
    );
    if (Varmi.length > 0) {
      var rowsParam = [
        ...SubeZimmetData.map(item => ({
          ...item
        }))
      ];
      var rowsParamIndex = SubeZimmetData.findIndex(
        d => d.MALZEME_STOK_NO === Barcode && d.FIS_NO === 'Fişsiz Malzeme'
      );
      rowsParam[rowsParamIndex].Count =
        parseInt(rowsParam[rowsParamIndex].Count) + 1;
      setSubeZimmetData(rowsParam);
      return;
    }
    axios
      .get('GetMaterialDescription/' + Barcode)
      .then(response => {
        if (response.data === '') {
          setUyariTip('error');
          setUyariAciklama(Barcode + ' stok numaralı malzeme sistemde tanımlı degil!...');
          setUyari(true);
          return;
        }
        SetBarcodeAddItemKabul(Barcode, response.data);
      })
      .catch(error => {
        setUyariTip('error');
        setUyariAciklama('Bir hata oluştu lütfen tekrar deneyiniz!...');
        setUyari(true);
        return;
      });
  };

  const SepeteEkleDetay = event => {
    setLoading(true);
    const data = {
      MALZEME_STOK_NO: MalzemeSiparis,
      BIRIM_KODU: SessionUser.ServiceShopId,
      TEKNISYEN_KODU: SessionUser.OrganizationUserId,
      ADET: siparisAdet
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetMaterialBasket', data, config)
      .then(response => {
        if (response.data[0].ErrorCode === '0') {
          var Deger = getSepetAdet();
          setSepetAdet(parseInt(Deger) + 1);
          setUyariTip('success');
          setUyariAciklama('İşlem başarılı');
          setUyari(true);

        } else {
          setUyariTip('error');
          setUyariAciklama(response.data[0].ErrorDescription);
          setUyari(true);
        }
        setLoading(false);
        setopenSiparisAdet(false);
        setsiparisAdet(1);
      })
      .catch(error => {
        setUyariTip('error');
        setUyariAciklama('Bir hata oluştu!..' + error.message);
        setUyari(true);
        setLoading(false);
      });
  };

  const SepeteEkle = (event, MALZEME_STOK_NO) => {
    setMalzemeSiparis(MALZEME_STOK_NO);
    setSiparisAdetTitle(
      MALZEME_STOK_NO +
      ' numaralı malzeme sipariş verebilmeniz için sepete eklenecektir!... Devam etmek istediğinizden emin misiniz?'
    );
    setopenSiparisAdet(true);
  };
  const handleCloseSiparisAdet = () => {
    setopenSiparisAdet(false);
    setsiparisAdet(1);
  };
  const handleSliderChange = (event, newValue) => {
    setsiparisAdet(newValue);
    if (Number(newValue) < 0) {
      setsiparisAdet(0);
    } else if (Number(newValue) > 999) {
      setsiparisAdet(999);
    }
  };
  const handleInputChange = event => {
    setsiparisAdet(event.target.value === '' ? '' : Number(event.target.value));
    if (Number(event.target.value) < 0) {
      setsiparisAdet(0);
    } else if (Number(event.target.value) > 999) {
      setsiparisAdet(999);
    }
  };
  const handleBlur = () => {
    if (siparisAdet < 0) {
      setsiparisAdet(0);
    } else if (siparisAdet > 999) {
      setsiparisAdet(999);
    }
  };

  const search = "";

  const setAdres = (param, index, MALZEME_STOK_NO) => {
    axios.get(`/GetAdresMalzemeKullanilabilirAdet/${SessionUser.ServiceShopId}/${param.Id}/${MALZEME_STOK_NO}`)
      .then(response => {

        let old_rows = [...SubeZimmetData];
        var filteredRowIndex = old_rows.findIndex(d => d.IDKONTROL === index);
        old_rows[filteredRowIndex].WarehouseAddress = param?.Id || 0;
        old_rows[filteredRowIndex].WarehouseAddressText = param?.Description || 0;
        old_rows[filteredRowIndex].Malzemeleri = param?.Materials || 0;
        old_rows[filteredRowIndex].ADRES_ADET = response.data;
        setSubeZimmetData(old_rows);
      })
      .catch(error => {
        console.log(error);
      });
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, Header } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
    return (
      <TableHead>
        <TableRow>
          {Header.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={'left'}
              padding={headCell.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {''}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const headMalzemeZimmetCells = [
    { id: 'RowSelected', numeric: true, disablePadding: true, label: 'Seçim' },
    { id: 'MALZEME_STOK_NO', numeric: true, disablePadding: true, label: 'MalzemeStokNo' },
    { id: 'MALZEME', numeric: true, disablePadding: true, label: 'Malzeme' },
    { id: 'DEPO_ADET', numeric: true, disablePadding: true, label: 'DepoAdet' },
    { id: 'ADRES_ADET', numeric: true, disablePadding: true, label: 'AdresAdet' },
    { id: 'Count', numeric: true, disablePadding: true, label: 'ÇıkışAdet' },
    { id: 'WarehouseAddressText', numeric: false, disablePadding: true, label: 'Adres' },
    { id: 'FIS_NO', numeric: true, disablePadding: true, label: 'Resim' },
    { id: 'FIS_NO', numeric: true, disablePadding: true, label: 'Bülten' },
    { id: 'FIS_NO', numeric: true, disablePadding: true, label: 'Sil' },
    { id: 'FIS_NO', numeric: true, disablePadding: true, label: 'Sipariş' },

  ];

  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="Stok Çıkışı - Şubeye Transfer" />
          <Divider />
          <Snackbar open={uyari} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyariTip}>
              {uyariAciklama || ''}
            </Alert>
          </Snackbar>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={2}>
                <Card className={classes.cardUstBolum}>
                  <CardHeader title="Şube İşlemleri" />
                  <Backdrop className={classes.backdrop} open={Loading}>
                    <CircularProgress color="inherit" />
                  </Backdrop>
                  <Divider />
                  <CardContent>
                    <FormControl variant="outlined" className={classes.fields}>
                      <Typography
                        className={classes.title}
                        color="textSecondary"
                        gutterBottom
                      >
                        Şube
                      </Typography>
                      <Typography variant="h6" component="h2">
                        <Select
                          native
                          value={SubeKodu}
                          onChange={handleSubeChange}
                          fullWidth
                          labelId="sube_label"
                          inputProps={{
                            name: 'sube_select',
                            id: 'sube_select'
                          }}
                        >
                          <option value="" defaultValue>
                            {SubeKodu}
                          </option>
                          {SubeData.map(p => {
                            return (
                              <option
                                key={p.SUBE_KODU}
                                value={p.SUBE_KODU}
                              >
                                {p.KUL_SUBE_KODU + '-' + p.ACIKLAMA}
                              </option>
                            );
                          })}
                        </Select>
                      </Typography>
                    </FormControl>
                  </CardContent>
                  <Divider />
                  <CardActions className={classes.actionsKesifSms}>
                    <Button
                      variant="contained"
                      color="secondary"
                      fullWidth
                      endIcon={<SearchIcon>Sorgula</SearchIcon>}
                      onClick={onSorgula}
                    >
                      Sorgula
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={10}>
                <Card className={classes.cardUstBolum}>
                  <CardHeader
                    title="İşlemler"
                    action={
                      <Button
                        variant="contained"
                        className={classes.button}
                        color="secondary"
                        endIcon={<SendIcon></SendIcon>}
                        onClick={event => CikisYap(event)}
                      >
                        Çıkış Yap
                      </Button>
                    }
                  />
                  <Divider />
                  <CardActions>
                    <FormControl fullWidth className={classes.margin}>
                      <TextField
                        label="Barkod"
                        value={Barcode}
                        name={Barcode}
                        className={clsx(classes.margin, classes.textField)}
                        onChange={event => {
                          setBarcode(event.target.value);
                        }}
                        onKeyPress={event => {
                          if (event.key === 'Enter') {
                            SetBarcodeAddItem(event.target.value);
                          }
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <CropFreeIcon />
                            </InputAdornment>
                          )
                        }}
                      />
                    </FormControl>
                  </CardActions>
                  <Divider />
                  <CardContent>
                    <TableContainer className={classes.container}>
                      <Table
                        size="small"
                        stickyHeader>
                        <EnhancedTableHead
                          classes={classes}
                          order={order}
                          orderBy={orderBy}
                          onRequestSort={handleRequestSort}
                          Header={headMalzemeZimmetCells}
                        />
                        <TableBody>
                          {stableSort(SubeZimmetData, getComparator(order, orderBy))
                            .map((row, index) => {
                              const isItemSelected = isSelected(index);
                              const labelId = `enhanced-table-checkbox-${index}`;
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  aria-checked={isItemSelected}
                                  tabIndex={-1}
                                  key={index}
                                  selected={isItemSelected}
                                >
                                  <TableCell padding="checkbox">
                                    {parseInt(row.DEPO_ADET) > 0 ? (
                                      <Checkbox
                                        onClick={event =>
                                          handleClick(event, row, index)
                                        }
                                        checked={row.RowSelected === 1 ? true : false}
                                        color="primary"
                                        inputProps={{
                                          'aria-labelledby': labelId
                                        }}
                                      />
                                    ) : (
                                      ''
                                    )}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.MALZEME_STOK_NO}
                                  </TableCell>
                                  <TableCell
                                    align="left" padding='none'
                                    title={row.MALZEME}
                                    className={classes.tableCell}
                                  >
                                    {row.MALZEME.substring(0, 10)}...
                                  </TableCell>
                                  <TableCell
                                    align="center" padding='none'
                                    className={classes.tableCell}
                                  >
                                    {parseInt(row.DEPO_ADET) > 0 ? (
                                      parseInt(row.DEPO_ADET, 10)
                                    ) : (
                                      <b style={{ color: 'red' }}>
                                        {parseInt(row.DEPO_ADET, 10)}
                                      </b>
                                    )}
                                  </TableCell>
                                  <TableCell
                                    align="center" padding='none'
                                    className={classes.tableCell}
                                  >
                                    {parseInt(row.ADRES_ADET) > 0 ? (
                                      parseInt(row.ADRES_ADET, 10)
                                    ) : (
                                      <b style={{ color: 'red' }}>
                                        {parseInt(row.ADRES_ADET, 10)}
                                      </b>
                                    )}
                                  </TableCell>
                                  {row.RowSelected === 1 ? (
                                    <CustomTableCell
                                      {...{ row, name: 'Count', onChange, Adet: row.ADRES_ADET }}
                                    />
                                  ) : (
                                    <TableCell
                                      align="left" padding='none'
                                      className={classes.tableCell}
                                    >
                                      <TextField
                                        type="number"
                                        disabled
                                        value={row.Count}
                                        inputProps={{
                                          min: 0,
                                          style: { textAlign: 'center' }
                                        }}
                                        style={{ width: 80 }}
                                      />
                                    </TableCell>
                                  )}
                                  <TableCell align="left" padding='none'>
                                    {

                                      row.DEPO_ADET > 0 ?
                                        <AddressSearch
                                          setAdres={setAdres}
                                          value={{
                                            Id: row.WarehouseAddress || '0',
                                            Description: row.WarehouseAddressText || 'Adres Seçiniz!...',
                                            Materials: row.Malzemeleri | ''
                                          } || ''}
                                          searchParam={search}
                                          MaterialCode={row.MALZEME_STOK_NO}
                                          ServicePaperNr={row.FIS_NO}
                                          index={row.IDKONTROL}
                                          Adres={row.WarehouseAddress || 0}
                                          RowSelected={row.RowSelected || 0}
                                          Tip={"Cikis1"}
                                        />
                                        :
                                        <TextField
                                          type="text"
                                          style={{ width: 200 }}
                                          disabled
                                          value={"Malzeme Adresi Bulunmuyor!.."}
                                          fullWidth
                                        />
                                    }
                                  </TableCell>
                                  <TableCell
                                    align="left" padding='none'
                                    className={classes.tableCell}
                                  >
                                    <ImageSearchIcon
                                      onClick={event =>
                                        GetMaterialImage(
                                          event,
                                          row.MALZEME_STOK_NO
                                        )
                                      }
                                      color="primary"
                                    />
                                  </TableCell>
                                  <TableCell
                                    align="left" padding='none'
                                    className={classes.tableCell}
                                  >
                                    <FindInPageIcon
                                      onClick={event =>
                                        GetMaterialBulletin(
                                          event,
                                          row.MALZEME_STOK_NO
                                        )
                                      }
                                      color="primary"
                                    />
                                  </TableCell>
                                  <TableCell
                                    align="left" padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.ID === 0 ? (
                                      ''
                                    ) : (
                                      <DeleteForeverIcon
                                        onClick={event =>
                                          SetMaterialDelete(event, row, row.ID)
                                        }
                                        color="primary"
                                      />
                                    )}
                                  </TableCell>
                                  <TableCell
                                    align="left" padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.SIP_VERILEBILIR === 0 ?
                                      <LockIcon color="error" />
                                      :
                                      <AddShoppingCartIcon
                                        onClick={(event) => SepeteEkle(event, row.MALZEME_STOK_NO)}
                                        color="primary"
                                      />
                                    }

                                  </TableCell>
                                </TableRow>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={bultenOpen}
        onClose={() => setBultenOpen(false)}
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle id="alert-dialog-title">
          Malzemeye Ait Bültenler
        </DialogTitle>
        <DialogContent>
          {LoadingMaterial ? (
            <LinearProgress status="loading" />
          ) : (
            <GenericBulten param={bultenParam} />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setBultenOpen(false)}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openMaterialFile}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseMaterialFile}
      >
        <DialogTitle>{openMaterialFileTitle}</DialogTitle>
        <DialogContent>
          {LoadingMaterial ? (
            <LinearProgress status="loading" />
          ) : (
            <img style={{ width: '100%' }} alt="" src={ImageUrl} />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMaterialFile} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openSiparisAdet}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseSiparisAdet}
      >
        <DialogTitle>{SiparisAdetTitle}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Typography id="input-slider" gutterBottom>
              Sipariş Adet
            </Typography>
            <Grid item xs={12} sm={12}>
              <Slider
                value={typeof siparisAdet === 'number' ? siparisAdet : 0}
                onChange={handleSliderChange}
                aria-labelledby="input-slider"
                max={999}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <Input
                className={classes.input}
                value={siparisAdet}
                margin="dense"
                fullWidth
                onChange={handleInputChange}
                onBlur={handleBlur}
                inputProps={{
                  step: 10,
                  min: 0,
                  max: 100,
                  type: 'number',
                  'aria-labelledby': 'input-slider'
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={SepeteEkleDetay} color="primary">
            Ekle
          </Button>
          <Button onClick={handleCloseSiparisAdet} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default Branch;
